module.exports = __webpack_public_path__ + "img/gold-PlatedCables.0915d39c.png";